import React from 'react';
import { Footer } from 'react-daisyui'

export const DaisyFooter = () => {
    return(
        <div>
            <Footer className="bottom-0 left-0 right-0 p-10 bg-neutral text-neutral-content">
                <div>
                    <div className="flex items-center gap-2 mb-4">
                      <img src="/beanbag-app-logo.png" alt="Beanbag" className="w-10 h-10" />
                      <span className="text-xl font-bold">Beanbag</span>
                    </div>
                    <p>
                    Find your perfect gaming teammates.<br />
                    Swipe, match, and game on.
                    </p>
                </div>

                <div>
                    <Footer.Title>Product</Footer.Title>
                    <a href="#features" className="link link-hover">Features</a>
                    <a href="#screenshots" className="link link-hover">Screenshots</a>
                </div>
                <div>
                    <Footer.Title>Company</Footer.Title>
                    <a href="#about" className="link link-hover">About</a>
                    <a href="#contact" className="link link-hover">Contact</a>
                    <a href="/privacy" className="link link-hover">Privacy Policy</a>
                    <a href="/terms" className="link link-hover">Terms</a>
                </div>
                <div>
                    <Footer.Title>Social</Footer.Title>
                    <a href="https://twitter.com" className="link link-hover" target="_blank" rel="noopener noreferrer">Twitter</a>
                    <a href="https://instagram.com" className="link link-hover" target="_blank" rel="noopener noreferrer">Instagram</a>
                    <a href="https://discord.com" className="link link-hover" target="_blank" rel="noopener noreferrer">Discord</a>
                </div>
            </Footer>
            <div className="bg-neutral text-neutral-content text-center py-4 text-sm">
              © 2026 Beanbag. All rights reserved.
            </div>
        </div>
    );
};

export default DaisyFooter;
